module.exports = __webpack_public_path__ + "static/img/corporate_culture_01.4d028e9.png";


//////////////////
// WEBPACK FOOTER
// ./src/common/ter/images/corporate_culture_01.png
// module id = Cjn4
// module chunks = 0